<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :nombre="nombre"
          :direccion="direccion"
          :incluirInactivos="incluirInactivos"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card :header="headerTitle" >
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="destinos" 
              :fields="itemFields"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(inactivo)="data">
              {{ data.item.inactivo ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Destino</b-dropdown-item>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Inactivar Destino</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregar">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import Filtro from './listFiltro.vue';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'remitosdestinos/getField',
  mutationType: 'remitosdestinos/updateField',
});

export default {
  name: 'RemitosDestinos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal
  ],
  data: () => {
    return {
      itemFields: [
        {
          key: 'nombre',
          sortable: true
        },
        { key: 'direccion' },
        { key: 'pais' },
        { key: 'provincia' },
        { key: 'localidad' },
        {
          key: 'inactivo',
        },
        {
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'destinos',
      'nombre',
      'direccion',
      'incluirInactivos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    headerTitle() {
      let title = "Listado de Destinos";
      return title;
    }
  },
  created() {
    this.$store.dispatch('remitosdestinos/inicializar')
      .then(() => this.getItems())
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    filtrar(filtro) {
      this.nombre = filtro.nombre;
      this.direccion = filtro.direccion;
      this.incluirInactivos = filtro.incluirInactivos;
      this.paginaActual = 1;

      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('remitosdestinos/getRemitosDestinos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    consultar (item) {
      this.$router.push({ name: 'RemitoDestinoData', 
                          params: { id: item.id }});
    },
    agregar () {
      this.$router.push({ name: 'RemitoDestinoABM', 
                          params: { id: 0 }
                        });
    },
    editar (item) {
      this.$router.push({ name: 'RemitoDestinoABM', 
                          params: { id: item.id }
                        });
    },
    borrar (item) {
      this.showModalConfirm('¿Desea inactivar el destino seleccionado?', 
            this.inactivar.bind(this, item.id), 'Si', null, 'No')
    },
    inactivar (remitoDestinoId) {
      this.showSpinner();
      this.$store.dispatch('remitodestino/inactivar', remitoDestinoId)
        .then(() => this.showModalMsj('El destino se inactivó con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },    
    goBack() {
      this.$router.go(-1);
    },    
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems() 
      }
    },    
  }    
}
</script>

<style>
</style>
